module.exports = __webpack_public_path__ + "static/media/2.8e1cb723.jpg";